import { Card } from "@components/anti"
import { useWindowSize } from "@components/hooks/hooks"

export default function ProjectGalleryCard({
  title,
  image,
  imageMobile,
  link,
  className,
}) {
  const { width } = useWindowSize()
  return (
    <Card
      variant="overlay"
      imgRatio="r-1-1 r-md-4-5"
      img={
        width > 576
          ? image || "/img/sample/img-1.jpg"
          : imageMobile || image || "/img/sample/img-1.jpg"
      }
      title={title}
      link={link}
      imgAlt={title}
      className={className}
    />
  )
}
